// ===================================================
// components/Layout/NavFavoriteStar.jsx
// Quiet ★ for user favorites — not the HOT/NEW platform badge.
// ===================================================
import React from 'react';
import { Star } from 'lucide-react';

/**
 * @param {object} props
 * @param {boolean} [props.active] — filled when true; outline muted when false (optional preview)
 * @param {string} [props.title]
 * @param {string} [props.className]
 */
const NavFavoriteStar = ({ active = true, title = 'В избранном', className = '' }) => {
  if (!active) return null;
  return (
    <span
      className={`mb-nav-fav-star ${className}`.trim()}
      title={title}
      aria-label={title}
    >
      <Star size={12} strokeWidth={1.75} aria-hidden />
    </span>
  );
};

export default NavFavoriteStar;
